import { useContext } from "react";

/* styles */
import sizeStyle from "@styles/pdp/SizePicker.module.scss";
import inseamStyle from "@styles/pdp/InseamPicker.module.scss";

/* context */
import context from "@context/pdp";
import { setInseam } from "@context/pdp/actions";

export default function InseamPicker() {
  const { state, dispatch } = useContext(context);
  const inseamsUnordered = !state.bundleConfiguration[
    state.step.product.id
  ].size
    ? state.step.product.inseam
    : state.step.product.originalVariants
        .filter(
          (variant) =>
            variant.id.includes(
              state.step.product.id.substr(state.step.product.id.length - 3),
            ) &&
            variant.attributes.waist ===
              state.bundleConfiguration[state.step.product.id].size,
        )
        .map((variant) => ({
          stock: variant.productInventoryState === "OutOfStock" ? false : true,
          inseamKey: variant.attributes.inseam,
          inseam: state.step.product.inseamLabels[variant.attributes.inseam],
        }));

  const order = ["SHT", "REG", "LNG"];
  const sortByObject = order.reduce((obj, item, index) => {
    return {
      ...obj,
      [item]: index,
    };
  }, {});
  const inseams =
    inseamsUnordered.length > 1
      ? inseamsUnordered.sort(
          (a, b) =>
            sortByObject[(order, a.inseamKey)] -
            sortByObject[(order, b.inseamKey)],
        )
      : inseamsUnordered;

  const getClassName = (inseam) => {
    let className = `${sizeStyle.sizePickerItem} ${inseamStyle.inseamPickerItem}`;

    const isInseamGenerallyAvailable = state.step.product.originalVariants.find(
      (variant) =>
        variant.attributes.inseam === inseam.inseamKey &&
        variant.attributes.color === state.step.product.variant.code &&
        variant.productInventoryState === "InStock",
    )
      ? true
      : false;

    if (
      inseam.inseamKey ===
        state.bundleConfiguration[state.step.product.id]?.inseamKey &&
      inseam.stock === true
    ) {
      className += ` ${sizeStyle.sizePickerItemSelected} `;
    }

    if (
      (!inseam.stock &&
        state.bundleConfiguration[state.step.product.id].size) ||
      !isInseamGenerallyAvailable
    ) {
      className += ` ${sizeStyle.sizePickerItemDisabled}`;
    }

    return className;
  };

  return (
    <div className={inseamStyle.inseamPicker}>
      {inseams.map((item) => (
        <div
          key={item.inseam.toLowerCase()}
          className={getClassName(item)}
          onClick={() => setInseam({ state, dispatch }, item)}
        >
          {item.inseam.toLowerCase()}
        </div>
      ))}
    </div>
  );
}
